import { Droppable, Draggable } from '@hello-pangea/dnd';
import DeliveryCard from './DeliveryCard';

export default function PeriodSection({ id, label, deliveries, onCardClick, onPrepChange, livreurColors, onReportToggle }) {
    // Regroupe les indices par groupe de livreur consécutif
    const groups = [];
    deliveries.forEach((delivery, index) => {
        const livreurId = delivery.livreur?.['@id'] || (delivery.livreur?.id ? `/api/users/${delivery.livreur.id}` : null);
        const lastGroup = groups[groups.length - 1];
        if (lastGroup && lastGroup.livreurId === livreurId) {
            lastGroup.items.push({ delivery, index });
        } else {
            groups.push({ livreurId, items: [{ delivery, index }] });
        }
    });

    return (
        <div style={{marginBottom: '12px'}}>
            <div style={{
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                color: 'var(--text-muted)',
                marginBottom: '6px',
                letterSpacing: '0.05em',
            }}>
                {label}
            </div>

            <Droppable droppableId={id}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{
                            minHeight: '60px',
                            backgroundColor: snapshot.isDraggingOver ? '#ede9fe' : 'var(--card-bg-secondary)',
                            borderRadius: '8px',
                            padding: '6px',
                            transition: 'background-color 0.2s ease',
                        }}
                    >
                        {groups.map((group, groupIndex) => {
                            const groupColor = livreurColors[group.livreurId] || '#94a3b8';
                            return (
                                <div
                                    key={group.livreurId || `group-${groupIndex}`}
                                    style={{
                                        backgroundColor: groupColor + '14',
                                        border: `1px solid ${groupColor}40`,
                                        borderRadius: '8px',
                                        padding: '4px',
                                        marginBottom: '8px',
                                    }}
                                >
                                    {group.items.map(({delivery, index}) => (
                                        <Draggable
                                            key={String(delivery.id)}
                                            draggableId={String(delivery.id)}
                                            index={index}
                                        >
                                            {(provided) => (
                                                <DeliveryCard
                                                    delivery={delivery}
                                                    provided={provided}
                                                    onClick={() => onCardClick(delivery)}
                                                    onPrepChange={(newStatut) => onPrepChange(delivery.id, newStatut)}
                                                    onReportToggle={(value) => onReportToggle && onReportToggle(delivery.id, value)}
                                                    livreurColors={livreurColors}
                                                />
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            );
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
}
